import { SET_UTILITY_INPUTS_IS_VISIBLE } from './constants';

const defaultState = {
    isVisible: false,
};

const utilityInputsUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_UTILITY_INPUTS_IS_VISIBLE:
            return { ...state, isVisible: action.isVisible };

        default:
            return state;
    }
};

export default utilityInputsUI;



// WEBPACK FOOTER //
// ./src/containers/Inputs/UtilityInputs/reducer.js